import { render, staticRenderFns } from "./Myteacher.vue?vue&type=template&id=29d67378&scoped=true&"
import script from "./Myteacher.vue?vue&type=script&lang=js&"
export * from "./Myteacher.vue?vue&type=script&lang=js&"
import style0 from "./Myteacher.vue?vue&type=style&index=0&id=29d67378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d67378",
  null
  
)

/* custom blocks */
import block0 from "./Myteacher.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports